export const isRichTextHtmlEmpty = (html?: string | null): boolean => {
  if (!html?.trim()) {
    return true;
  }

  const doc = new DOMParser().parseFromString(html, 'text/html');
  const body = doc.body;

  if (body.querySelector('img, video')) {
    return false;
  }

  const text = (body.textContent || '').replace(/\u00A0/g, ' ').trim();
  return text.length === 0;
};
